// Structured data (JSON-LD) for <script type="application/ld+json">. Text comes from the database (and, for SEO
// Studio articles, from an AI model), so every character that could end the script element or confuse an HTML
// parser is written as a JSON unicode escape. The JSON stays valid and means exactly the same thing.
export const jsonLd = (obj) => JSON.stringify(obj)
  .replace(/[<>&\u2028\u2029]/g, (c) => `\\u${c.charCodeAt(0).toString(16).padStart(4, '0')}`);

// FAQPage for the questions shown on the page (Google requires the answers to be visible there too).
export const faqPageLd = (faqs, url) => {
  const items = (faqs || []).filter((f) => f && f.question && f.answer);
  if (!items.length) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    ...(url ? { url } : {}),
    mainEntity: items.map((f) => ({
      '@type': 'Question',
      name: String(f.question),
      acceptedAnswer: { '@type': 'Answer', text: String(f.answer) },
    })),
  };
};
